module.exports = __webpack_public_path__ + "static/media/bhavesh.613d7946.jpeg";